export default __webpack_public_path__ + "static/media/android.7846af2b.png";